import React from 'react';
import { ORDER_STATUS_LABELS } from '../../constants';
import { formatPrice, formatDisplayPhone } from '../../utils';
import { useLanguage } from '../../i18n/LanguageContext';
import './CustomerCard.css';

const CustomerCard = ({ 
  customer, 
  onEdit, 
  onCopy,
  onDelete, 
  isLoading, 
  formatDate,
  remainingAmount,
  permissions = {} // Rol bazlı yetkiler
}) => {
  const { t, language } = useLanguage();
  const statusKey = customer.orderStatus || 'new_order';

  return (
    <div className="customer-card">
      <div className="card-header">
        <div className="customer-name">
          <h4>{customer.name}</h4>
        </div>
        <span className={`status-badge status-${statusKey}`}>
          {t('orderStatus.' + statusKey, ORDER_STATUS_LABELS[statusKey])}
        </span>
      </div>
      
      <div className="card-content">
        <div className="card-info">
          <div className="info-item">
            <i className="fas fa-phone"></i>
            <span>{formatDisplayPhone(customer.phone1)}</span>
          </div>
          
          {customer.phone2 && (
            <div className="info-item">
              <i className="fas fa-phone"></i>
              <span>{formatDisplayPhone(customer.phone2)}</span>
            </div>
          )}
          
          {customer.email && (
            <div className="info-item">
              <i className="fas fa-envelope"></i>
              <span>{customer.email}</span>
            </div>
          )}
          
          
          {customer.inspectionDate && (
            <div className="info-item">
              <i className="fas fa-clipboard-check"></i>
              <span>{t('customer.inspectionDate', 'Keşif')}: {formatDate(customer.inspectionDate)} {customer.inspectionCompleted ? `✓ (${language === 'nl' ? 'Voltooid' : 'Yapıldı'})` : ''}</span>
            </div>
          )}

          <div className="info-item">
            <i className="fas fa-calendar"></i>
            <span>{t('customer.orderDate', 'Sipariş')}: {formatDate(customer.orderDate)}</span>
          </div>
          
          <div className="info-item">
            <i className="fas fa-calendar-check"></i>
            <span>{t('customer.deliveryDate', 'Teslimat')}: {formatDate(customer.deliveryDate)}</span>
          </div>
          
          {customer.address && (
            <div className="info-item address">
              <i className="fas fa-map-marker-alt"></i>
              <span>{customer.address}</span>
            </div>
          )}
          
          {customer.notes && (
            <div className="info-item notes">
              <i className="fas fa-sticky-note"></i>
              <span>{customer.notes}</span>
            </div>
          )}

          <div className="info-item remaining-payment">
            <i className="fas fa-money-bill-wave"></i>
            <span>
              {t('customer.remainingAmount', 'Kalan Ödeme')}: {
                remainingAmount !== undefined ? (
                  remainingAmount === -1 ? (
                    <span className="no-order">
                      <i className="fas fa-minus-circle"></i> {language === 'nl' ? 'Geen bestelling' : 'Sipariş Yok'}
                    </span>
                  ) : (customer.isPaymentCompleted || remainingAmount === 0) ? (
                    <span className="payment-completed">
                      <i className="fas fa-check-circle"></i> {t('orderSummary.paymentReceived', 'Ödeme Alındı')}
                    </span>
                  ) : (
                    <span className="remaining-amount">{formatPrice(remainingAmount)} €</span>
                  )
                ) : (
                  <span className="loading-amount">...</span>
                )
              }
            </span>
          </div>
        </div>
      </div>
      
      <div className="card-actions">
        {/* Düzenleme butonu - Montajcı da görür (durum güncelleme için) */}
        <button 
          onClick={() => onEdit(customer)}
          className="edit-btn"
          disabled={isLoading}
          title={permissions?.canEditCustomer ? t('common.edit', 'Düzenle') : (language === 'nl' ? 'Details' : 'Detaylar')}
        >
          <i className={`fas ${permissions?.canEditCustomer ? 'fa-edit' : 'fa-eye'}`}></i>
        </button>
        
        {/* Kopyalama butonu - Montajcı göremez */}
        {permissions?.canCreateCustomer && (
          <button 
            onClick={() => onCopy(customer)}
            className="copy-btn"
            disabled={isLoading}
            title={language === 'nl' ? 'Klant kopiëren' : 'Müşteriyi Kopyala'}
          >
            <i className="fas fa-copy"></i>
          </button>
        )}
        
        {/* Silme butonu - Montajcı göremez */}
        {permissions?.canDeleteCustomer && (
          <button 
            onClick={() => onDelete(customer)}
            className="delete-btn"
            disabled={isLoading}
            title={t('common.delete', 'Sil')}
          >
            <i className="fas fa-trash"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default CustomerCard; 